import { useEffect } from 'react';
import { generatePath, Outlet, useNavigate, useParams } from 'react-router-dom';
import { tr } from '@repo/locale';
import { TestId } from '@repo/test-id';
import { toast } from '@repo/toast';

import { useParkingContext } from '@features/ownedParkingManage/contexts/ParkingContext';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function SpotExistsGuard() {
  const { spotId, id: parkingId } = useParams<{ spotId: string; id: string }>();
  const parking = useParkingContext();
  const navigate = useNavigate();

  const spot = parking.spots.find((spot) => spot.id === spotId);

  useEffect(() => {
    if (!spot) {
      const testId = TestId.root('spotExistsGuardError');
      toast.danger(tr('owned_parking_manage:manage.spots.errors.spot_not_found'), testId);
      navigate(generatePath(ROUTE_PATHS[RouteName.MY_PARKING_MANAGE_SPOTS], { id: parkingId }), { replace: true });
    }
  }, [spot, navigate, parkingId]);

  if (!spot) {
    return null;
  }

  return <Outlet context={spot} />;
}
